/**
 * @author xiaohuangmaoth
 * @description 组织路径完成率
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';
import { mapStateToProps, handleExport } from '../../utils';

const { WizContainer, WizReduxTemplate } = framework_tool;

class OrgPathCompletion extends WizContainer {
  componentName = "OrgPathCompletion";

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        state: val.state!=null && val.state===1 ? '草稿' : val.state!=null && val.state===2 ?
        '已发布':val.state!=null && val.state===3 ? '已关闭' : '未输入',
      }))

      const title = '组织路径完成率'

      WizBrowserExport({
        title,
        sheetName: title,
        columns: column.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true

    } else {
      wizNotice.error(msg)
      return false;
    }

  }
  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(mapStateToProps.bind(this, { nameSpace: 'pathReport', method: 'getPageListOrg' }))(OrgPathCompletion);
